import { ElementRef, Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class ScrollService {

    constructor() { }

    public static scrollTo(target: string) {
        this.scrollToElement(document.getElementById(target));
    }

    public static scrollToElement(element: HTMLElement | null) {
      element?.scrollIntoView({
          behavior: 'smooth'
      });
    }

    public static scrollToBottom(target: string) {
      const element = document.querySelector<HTMLElement>(target);
      if (element){
        const bottomPosition = element.offsetHeight + element.offsetTop + ( element.offsetParent ? (<HTMLElement>element.offsetParent).offsetTop : 0 );
        window.scrollTo({top: bottomPosition, behavior: 'smooth'})
      }
    }
}
